import { SplashScreen } from "@boundary/components/splashScreen";
import { useAppInitialization } from "@boundary/_hooks";

export function SplashPage() {
  console.log("[SplashPage] Rendering splash page, calling useAppInitialization...");
  useAppInitialization();

  return <SplashScreen />;
}
